import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#505867",
      "fill-rule": "evenodd",
      d: "M8 14.4a.6.6 0 0 1-.6-.6V3.728l-1.56 1.68a.6.6 0 1 1-.88-.816l2.6-2.8a.6.6 0 0 1 .88 0l2.6 2.8a.6.6 0 0 1-.88.816L8.6 3.728V13.8a.6.6 0 0 1-.6.6M16 1.6a.6.6 0 0 1 .6.6v10.072l1.56-1.68a.6.6 0 1 1 .88.816l-2.6 2.8a.6.6 0 0 1-.88 0l-2.6-2.8a.6.6 0 0 1 .88-.816l1.56 1.68V2.2a.6.6 0 0 1 .6-.6",
      "clip-rule": "evenodd",
      style: {"fill":"color(display-p3 .3137 .3451 .4039)","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }